export default ({...props}) => {
  const {space, unit} = props.theme
  return `
        display: flex;
        flex-flow: column;
        height: ${unit(100)}%;
        gap: ${space(2)}px;
        justify-content: center;
        align-items: center;
        background-color: #fafafa;
        padding: ${space(2)}px;

        & [ap_atom_name="typographyAtom"] {
            margin: 0;
        }
        
    `
}
